import createDomPurify from 'dompurify';
import {Remarkable} from 'remarkable-v2';

const markdownRenderer = new Remarkable('full', {
  html: true,
  linkTarget: '_blank',
});

const DOMPurify = createDomPurify();

DOMPurify.addHook('afterSanitizeAttributes', function (node) {
  // set all elements owning target to target=_blank
  if ('target' in node) {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener');
  }
});

const DOMPurifyRemoveTargetWhenEmbeded = createDomPurify();

DOMPurifyRemoveTargetWhenEmbeded.addHook(
  'afterSanitizeAttributes',
  function (node) {
    // if the href is a Dashboard link, remove target and rel so it can be handled by
    // widgetLinkAction, and Dashboard can do client side navigation.
    if (
      'target' in node &&
      node.tagName === 'A' &&
      node
        .getAttribute('href')
        ?.startsWith(document.location.ancestorOrigins[0])
    ) {
      node.removeAttribute('target');
    } else {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener');
    }
  },
);

export function renderMarkdownInline(
  text: string,
  options?: {removeTargetInLinks?: boolean},
) {
  const {removeTargetInLinks = false} = options || {};
  if (removeTargetInLinks) {
    return DOMPurifyRemoveTargetWhenEmbeded.sanitize(
      markdownRenderer.renderInline(text),
    );
  }

  return DOMPurify.sanitize(markdownRenderer.renderInline(text));
}

export function renderMarkdown(text: string) {
  return DOMPurify.sanitize(markdownRenderer.render(text));
}
